document.addEventListener('DOMContentLoaded', function() {
    const $ = window.jQuery;
    let currentMainCategory = null;
    let currentSubCategory = null;

    /**
     * Scrolls the page to the latest articles section
     * Takes into account the header and helper nav heights
     */
    function scrollToSection() {
        const $section = $('.block-latest-articles');
        if ($section.length) {
            const offset = $section.offset().top;
            const headerHeight = $('.site-header').outerHeight() || 0;
            const helperNavHeight = $('.helper-nav-container').outerHeight() || 0;
            $('html, body').animate({
                scrollTop: offset - headerHeight - helperNavHeight - 20
            }, 300);
        }
    }

    function updateArticleVisibility() {
        $('.articles-list .col').each(function() {
            const $article = $(this);
            const categories = $article.data('cats') || [];
            const parentCategories = $article.data('parent-cats') || [];

            if (currentSubCategory) {
                // If subcategory is selected, show articles with this subcategory 
                // OR articles with this subcategory's parent where the article might be in a different subcategory
                const currentSubParent = $(`.subcategory-buttons button[data-category="${currentSubCategory}"]`).data('parent-category');
                $article.toggle(
                    categories.includes(currentSubCategory) || 
                    (parentCategories.includes(currentSubParent) && categories.some(cat => {
                        // Check if any subcategory button with this article's category exists under the current parent
                        return $(`.subcategory-buttons[data-parent="${currentSubParent}"] button[data-category="${cat}"]`).length > 0;
                    }))
                );
            } else if (currentMainCategory === 'all-categories') {
                // If "Show all" is selected
                $article.show();
            } else if (currentMainCategory) {
                // If main category is selected, show its articles and direct subcategories
                $article.toggle(
                    categories.includes(currentMainCategory) || 
                    parentCategories.includes(currentMainCategory)
                );
            }
        });
    }

    // Use delegated event handling for all buttons
    $('.filters').on('click', 'button', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $button = $(this);
        const isSubcategory = $button.closest('.subcategory-buttons').length > 0;
        
        // Remove active class from all buttons
        $('.category-buttons button, .subcategory-buttons button').removeClass('active');
        
        if (isSubcategory) {
            // Handle subcategory click
            const category = $button.data('category');
            const parentCategory = $button.closest('.subcategory-buttons').data('parent');
            
            // Activate main category and subcategory
            $(`.main-categories button[data-category="${parentCategory}"]`).addClass('active');
            $button.addClass('active');
            
            // Show only this main category's subcategories
            $('.subcategory-buttons').hide();
            $(`.subcategory-buttons[data-parent="${parentCategory}"]`).show();
            
            // Update state
            currentMainCategory = parentCategory;
            currentSubCategory = category;
        } else {
            // Handle main category click
            const category = $button.data('category');
            $button.addClass('active');
            
            // Hide subcategories and show this category's subcategories
            $('.subcategory-buttons').hide();
            if ($button.data('has-subcategories') === true && category !== 'all-categories') {
                $(`.subcategory-buttons[data-parent="${category}"]`).show();
            }
            
            // Update state
            currentMainCategory = category;
            currentSubCategory = null;
        }
        
        // Update article visibility
        updateArticleVisibility();
        
        // Update URL hash - use data-category instead of button text
        const category = $button.data('category');
        window.location.hash = category;
    });

    // Initialize from hash if it exists
    if (window.location.hash) {
        const hash = window.location.hash.replace('#', '');
        let categoryFound = false;
        
        // Check subcategories first
        $('.subcategory-buttons button').each(function() {
            const category = $(this).data('category');
            if (category === hash) {
                $(this).trigger('click');
                categoryFound = true;
                return false;
            }
        });

        // If no subcategory found, check main categories
        if (!categoryFound) {
            $('.main-categories button').each(function() {
                const category = $(this).data('category');
                if (category === hash) {
                    $(this).trigger('click');
                    categoryFound = true;
                    return false;
                }
            });
        }

        // If category was found, scroll to section
        if (categoryFound) {
            const $section = $('.block-latest-articles');
            if ($section.length) {
                const offset = $section.offset().top;
                const headerHeight = $('.site-header').outerHeight() || 0;
                const helperNavHeight = $('.helper-nav-container').outerHeight() || 0;
                
                // Use small timeout to ensure DOM updates are complete
                setTimeout(() => {
                    $('html, body').animate({
                        scrollTop: offset - headerHeight - helperNavHeight - 20
                    }, 300);
                }, 100);
            }
        }
    }
}); 